import { ButtonERP } from "@finanedi.es/storybook"
import {
  faArrowLeft,
  faArrowsRotateReverse,
  faFileExport,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useDeclaracion349 } from "api/DeclaracionModelo.hook"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import Spinner from "common/components/Spinner"
import notification from "common/utils/notification"
import { TFunction } from "i18next"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import { getProvinceIneOptions } from "utils/provinceDropdownOptions"
import { getPeriodoDeclaracion } from "../../Modelo303/components/ResumenImpuestosDetail/DeclaracionModelo303/constants"
import { PlantillaDeclaracion } from "../../PlantillaDeclaracion"
import PlantillaDeclaracionEstandar from "../../PlantillaDeclaracionEstandar"
import ModalPresentarModelo349 from "./ModalPresentarModelo349"
import Operadores349 from "./Operadores349/Operadores349"

const SECCIONES_TYPES = {
  DEVENGO: 1,
  IDENTIFICACION: 2,
  RESUMEN_DATOS: 3,
  OPERADORES: 4,
  DECLARACION_COMPLEMENTARIA_SUSTITUTIVA: 5,
}
const SECCIONES = (t: TFunction) => [
  {
    id: SECCIONES_TYPES.DEVENGO,
    label: `${SECCIONES_TYPES.DEVENGO} - ${t(
      "taxSummary.declaracion.devengo"
    )}`,
  },
  {
    id: SECCIONES_TYPES.IDENTIFICACION,
    label: `${SECCIONES_TYPES.IDENTIFICACION} - ${t(
      "taxSummary.declaracion.identificacion"
    )}`,
  },
  {
    id: SECCIONES_TYPES.RESUMEN_DATOS,
    label: `${SECCIONES_TYPES.RESUMEN_DATOS} - ${t(
      "taxSummary.declaracion.summary"
    )}`,
  },
  {
    id: SECCIONES_TYPES.OPERADORES,
    label: `${SECCIONES_TYPES.OPERADORES} - ${t(
      "taxSummary.declaracion.operadores"
    )}`,
  },
  {
    id: SECCIONES_TYPES.DECLARACION_COMPLEMENTARIA_SUSTITUTIVA,
    label: `${SECCIONES_TYPES.DECLARACION_COMPLEMENTARIA_SUSTITUTIVA} - ${t(
      "taxSummary.declaracion.complementariaSustitutiva"
    )}`,
  },
]

const DeclaracionModelo349 = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [tabSelected, setSelectedTab] = useState(SECCIONES_TYPES.DEVENGO)
  const [showModalPresentar, setShowModalPresentar] = useState<boolean>(false)
  const [isUpdating, setIsUpdating] = useState<boolean>(false)
  const {
    activeCompany: { razonSocial, nif },
  } = useUsuarioEmpresaActiva()
  const { state } = useLocation() as {
    state?: { year?: number; periodo?: number }
  }
  const periodo = getPeriodoDeclaracion(state?.periodo)

  const {
    declaracion349Data,
    declaracion349DataIsLoading,
    declaracion349DataRefetch,
  } = useDeclaracion349({
    queryParams: {
      Anyo: Number(state?.year),
      PeriodoDeclaracion: periodo.value,
    },
  })
  const defaultValues = {
    declarante: {
      // apellidoNombrePersona: razonSocial, // apellidoNombrePersona y nombreDeclarante se envia con razonSocial a pedido del back
      // cambioPeriodicidadObligacionDeclarar: undefined, // cambioPeriodicidadObligacionDeclarar no se envia a pedido del back
      importeOperacionesIntracom: declaracion349Data?.casilla02,
      importeRectificaciones: declaracion349Data?.casilla04,
      nifDeclarante: nif,
      // nifRepresentante: nif,
      nombreDeclarante: razonSocial,
    },
    ejercicio: Number(state?.year),
    period: periodo,
    "01": declaracion349Data?.casilla01,
    "03": declaracion349Data?.casilla03,
    operadores: declaracion349Data?.operadores || [],
  }
  const { setValue, watch, reset } = useForm<$TSMigrationFixMe>({
    values: defaultValues,
    mode: "onChange",
    reValidateMode: "onChange",
  })

  const values = watch()

  const handleUpdateClick = async () => {
    setIsUpdating(true)
    try {
      const { data: updatedData } = await declaracion349DataRefetch()
      if (updatedData) {
        reset(defaultValues)
        notification.success({
          body: `${t("taxSummary.declaracion.successNotification")}`,
        })
        setIsUpdating(false)
      }
    } catch (error) {
      setIsUpdating(false)
      notification.errorServidor()
    }
  }

  return (
    <div className='tw-w-full tw-h-full tw-overflow-hidden tw-bg-white tw-text-left'>
      <div className='tw-h-fit tw-p-3 tw-w-full tw-bg-white tw-shadow'>
        <div className='tw-h-11 tw-flex tw-flex-row tw-w-full tw-items-center tw-justify-between'>
          <div className='tw-flex tw-flex-row tw-gap-4 tw-items-center tw-h-full'>
            <ButtonERP
              customize={{ size: "md", type: "transparent" }}
              onClick={() => history.goBack()}
              icon={<FontAwesomeIcon icon={faArrowLeft} />}
            />
            <span className='tw-rounded tw-h-fit tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#139144]'>
              {MODELO_IMPUESTO.MODELO_349}
            </span>
            <span className='tw-text-base tw-font-medium tw-h-fit'>
              {`${t("taxSummary.detail.title349")} - ${periodo.label} ${
                state?.year ?? new Date().getFullYear()
              }`}
            </span>
          </div>
          <div className='tw-flex tw-flex-row tw-gap-3'>
            <ButtonERP
              customize={{ size: "md", type: "transparent" }}
              label={`${t("taxSummary.declaracion.updateButton")}`}
              loading={isUpdating}
              disabled={isUpdating}
              icon={<FontAwesomeIcon icon={faArrowsRotateReverse} />}
              onClick={() => {
                handleUpdateClick()
              }}
            />
            <ButtonERP
              customize={{ size: "md", type: "primary" }}
              onClick={() => setShowModalPresentar(!showModalPresentar)}
              icon={<FontAwesomeIcon icon={faFileExport} />}
              label={`${t("taxSummary.declaracion.presentar")}`}
            />
          </div>
        </div>
      </div>

      <div className='tw-w-full tw-h-[calc(100%-68px)] tw-flex tw-flex-row'>
        <div className='tw-w-2/5 tw-p-6 tw-flex tw-flex-col tw-items-start tw-border-r tw-border-neutral-25'>
          <p className='tw-font-medium tw-text-base'>
            {t("taxSummary.declaracion.secciones")}
          </p>
          <div className='tw-flex tw-flex-col tw-items-start tw-mt-4 tw-w-full tw-gap-1 tw-text-left'>
            {SECCIONES(t).map(({ id, label }) => (
              <p
                key={id}
                className={`tw-h-10 tw-w-full tw-px-4 hover:tw-bg-neutral-25 ${
                  tabSelected === id ? "tw-bg-neutral-25" : ""
                } tw-flex tw-items-center tw-cursor-pointer tw-rounded tw-truncate`}
                onClick={() => setSelectedTab(id)}
              >
                {label}
              </p>
            ))}
          </div>
        </div>

        <div className='tw-w-4/5 tw-flex tw-flex-col tw-items-start tw-overflow-y-auto'>
          <div className='tw-w-full tw-text-base tw-font-medium tw-flex tw-items-center tw-justify-start tw-px-6 tw-py-4'>
            {SECCIONES(t).find((s) => s.id === tabSelected)?.label}
          </div>
          {declaracion349DataIsLoading ? (
            <Spinner />
          ) : (
            <>
              {tabSelected === SECCIONES_TYPES.DEVENGO && (
                <PlantillaDeclaracionEstandar
                  setValue={setValue}
                  fields={[
                    {
                      id: "row1",
                      inputsOne: [
                        {
                          label: t(
                            "taxSummary.declaracion.devengoModelo.ejercicio"
                          ),
                          code: "ejercicio",
                          value: state?.year ?? "",
                          inputType: "text",
                          disabled: true,
                        },
                        {
                          label: t(
                            "taxSummary.declaracion.devengoModelo.periodo"
                          ),
                          code: "period",
                          value: periodo.label,
                          inputType: "text",
                          disabled: true,
                        },
                      ],
                    },
                  ]}
                />
              )}
              {tabSelected === SECCIONES_TYPES.IDENTIFICACION && (
                <PlantillaDeclaracionEstandar
                  setValue={setValue}
                  fields={[
                    {
                      id: "row1",
                      inputsOne: [
                        {
                          label: t("taxSummary.declaracion.nif"),
                          code: "declarante.nifDeclarante",
                          value: values.declarante.nifDeclarante,
                          inputType: "text",
                          disabled: true,
                        },
                        {
                          label: t("taxSummary.declaracion.name"),
                          code: "declarante.nombreDeclarante",
                          value: values.declarante.nombreDeclarante,
                          inputType: "text",
                          disabled: true,
                          colSpan: "tw-col-span-2",
                        },
                        {
                          label: t("taxSummary.declaracion.telephone"),
                          code: "declarante.telefonoPersona",
                          value: values.declarante.telefonoPersona,
                          inputType: "text",
                          disabled: false,
                        },
                      ],
                    },
                    {
                      id: "row2",
                      columsNumber: "tw-grid-cols-6",
                      inputsOne: [
                        {
                          label: t(
                            "taxSummary.declaracion.addressForm.direccion"
                          ),
                          code: "declarante.direccion",
                          value: values.declarante.direccion,
                          inputType: "text",
                          colSpan: "tw-col-span-2",
                          disabled: false,
                        },
                        {
                          label: t("taxSummary.declaracion.addressForm.numero"),
                          code: "declarante.numero",
                          value: values.declarante.numero,
                          inputType: "text",
                        },
                        {
                          label: t(
                            "taxSummary.declaracion.addressForm.escalera"
                          ),
                          code: "declarante.escalera",
                          value: values.declarante.escalera,
                          inputType: "text",
                        },
                        {
                          label: t("taxSummary.declaracion.addressForm.piso"),
                          code: "declarante.piso",
                          value: values.declarante.piso,
                          inputType: "text",
                        },
                        {
                          label: t("taxSummary.declaracion.addressForm.puerta"),
                          code: "declarante.puerta",
                          value: values.declarante.puerta,
                          inputType: "text",
                        },
                      ],
                    },
                    {
                      id: "row3",
                      inputsOne: [
                        {
                          label: t(
                            "taxSummary.declaracion.addressForm.provincia"
                          ),
                          code: "declarante.provincia",
                          value: values.declarante.provincia,
                          inputType: "dropdown",
                          options: getProvinceIneOptions(t),
                          colSpan: "tw-col-span-2",
                        },
                        {
                          label: t(
                            "taxSummary.declaracion.addressForm.municipio"
                          ),
                          code: "declarante.municipio",
                          value: values.declarante.municipio,
                          inputType: "text",
                        },
                        {
                          label: t(
                            "taxSummary.declaracion.addressForm.codigoPostal"
                          ),
                          code: "declarante.codigoPostal",
                          value: values.declarante.codigoPostal,
                          inputType: "text",
                        },
                      ],
                    },
                  ]}
                />
              )}
              {tabSelected === SECCIONES_TYPES.RESUMEN_DATOS && (
                <PlantillaDeclaracion
                  setValue={setValue}
                  fields={[
                    {
                      label: t(
                        "declaracionModelo349.dataSummary.totalIntraOperators"
                      ),
                      code: "01",
                      value: values["01"],
                      disabled: false,
                      inputType: "numberGroup",
                    },
                    {
                      label: t(
                        "declaracionModelo349.dataSummary.intraOperationsAmount"
                      ),
                      code: "declarante.importeOperacionesIntracom",
                      value: values.declarante.importeOperacionesIntracom,
                      disabled: false,
                      inputNumber: "02",
                    },
                    {
                      label: t(
                        "declaracionModelo349.dataSummary.totalIntraOperatorsWithCorrections"
                      ),
                      code: "03",
                      value: values["03"],
                      disabled: false,
                      inputType: "numberGroup",
                    },
                    {
                      label: t(
                        "declaracionModelo349.dataSummary.correctionsAmount"
                      ),
                      code: "declarante.importeRectificaciones",
                      value: values.declarante.importeRectificaciones,
                      disabled: false,
                      inputNumber: "04",
                    },
                  ]}
                />
              )}
              {tabSelected === SECCIONES_TYPES.OPERADORES && (
                <Operadores349
                  setValue={setValue}
                  values={values}
                />
              )}

              {tabSelected ===
                SECCIONES_TYPES.DECLARACION_COMPLEMENTARIA_SUSTITUTIVA && (
                <PlantillaDeclaracion
                  isDeclaracion349
                  setValue={setValue}
                  fields={[
                    {
                      label: t(
                        "declaracionModelo349.complemementariaSustitutiva.complementaria"
                      ),
                      code: "declarante.declaracionComplementaria",
                      value: values.declarante.declaracionComplementaria,
                      inputType: "checkbox",
                    },
                    {
                      label: t(
                        "declaracionModelo349.complemementariaSustitutiva.sustitutiva"
                      ),
                      code: "declarante.declaracionSustitutiva",
                      value: values.declarante.declaracionSustitutiva,
                      inputType: "checkbox",
                    },
                    {
                      label: t(
                        "declaracionModelo349.complemementariaSustitutiva.numeroJustificante"
                      ),
                      code: "declarante.numeroIdentificativoDeclaracionAnterior",
                      value:
                        values.declarante
                          .numeroIdentificativoDeclaracionAnterior,
                      disabled: false,
                      inputType: "text",
                    },
                  ]}
                />
              )}
              <span className='tw-text-xs tw-text-left tw-w-full tw-py-1 tw-px-6'>
                {t("taxSummary.declaracion.infoMsg")}
              </span>
            </>
          )}
        </div>
      </div>

      <ModalPresentarModelo349
        show={showModalPresentar}
        setShow={setShowModalPresentar}
        watch={watch}
      />
    </div>
  )
}
export default DeclaracionModelo349
